import { render } from "./LoginpageCom.vue?vue&type=template&id=3f36ff66&scoped=true"
import script from "./LoginpageCom.vue?vue&type=script&lang=js"
export * from "./LoginpageCom.vue?vue&type=script&lang=js"

import "./LoginpageCom.vue?vue&type=style&index=0&id=3f36ff66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f36ff66"]])

export default __exports__